import { ReactElement } from 'react';

import { ActionEventInterceptor, ButtonVariant, ModalConfirmButton } from '@dreryk/react-components';

import { useAccountAuthorizationModal } from '~libs.desktop.shared.account';

import { medicalDocumentationCreateTranslationKeys } from '../../../translations';
import { MedicalDocumentationCreateFormController } from '../MedicalDocumentationCreateForm.types';

import { useGenerateDocumentationCommand } from './useGenerateDocumentationCommand';

type MedicalDocumentationDownloadUnencryptedActionProps = Pick<
   MedicalDocumentationCreateFormController,
   'handleSubmit'
> &
   Readonly<{
      patientId: number;
      onCreate: VoidFunction;
   }>;

export const MedicalDocumentationDownloadUnencryptedAction = (
   props: MedicalDocumentationDownloadUnencryptedActionProps
): ReactElement => {
   const { openAccountAuthorizationModal, renderAccountAuthorizationnModal } = useAccountAuthorizationModal();
   const { executeAsync: generateDocumentation } = useGenerateDocumentationCommand({
      patientId: props.patientId,
      onAuthenticationRequired: openAccountAuthorizationModal,
      encrypted: false,
   });

   return (
      <>
         <ActionEventInterceptor
            action={props.handleSubmit(generateDocumentation)}
            blockingOperation={medicalDocumentationCreateTranslationKeys.generatingDocumentation}
         >
            <ModalConfirmButton
               testId={'downloadUnencrypted'}
               label={medicalDocumentationCreateTranslationKeys.createPatientRecordsModal.actions.downloadUnencrypted}
               onClick={props.onCreate}
               variant={ButtonVariant.SECONDARY}
            />
         </ActionEventInterceptor>
         {renderAccountAuthorizationnModal({
            onAuthorization: props.handleSubmit(generateDocumentation),
         })}
      </>
   );
};
